<template>
  <div class="flex">
    <div class="container">
      <!-- 内容 -->
      <div class="top_cl">充值信息</div>
      <p>請<span style="color: red;"> 10 </span>分鍾以內完成支付</p>
      <div  class="el-table-page">
        <el-table :data="tableData" :show-header=false   class="tableCss custom-table-border"> <!--:row-style="{ height: '40px' }" :cell-style="{ padding: '0px' }"-->
          <el-table-column prop="key"  width="120"> </el-table-column>
          <el-table-column prop="val"  width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.key == '實際支付金額'">
                <span style="color: red;font-size: 22px;">{{ scope.row.val }}</span>
              </span>
              <span v-else> {{ scope.row.val }}</span>

              <el-tooltip class="item" effect="dark"  v-if = scope.row.icon   placement="top" content="点击复制" :enterable="false" :manual="true">
                <el-button
                    type="text"
                    size="small"
                    @click="copyText(scope.row.val)"
                    icon="el-icon-document-copy"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="top: 50px;">
        <div style="padding-top: 30px;">
          <el-button type="warning" @click="copy(1)">複製收款卡號</el-button>
        </div>
        <div style="padding-top: 10px;">
          <el-button type="success" @click="copy(2)">複製支付金額</el-button>
        </div>
      </div>
      <div class="b3">
        <p>1.請按<span style="color: red;">實際支付金額</span>支付，分數沒到帳請前住客服，謝謝。</p>
        <p>2.通道戶口不定時更新，請勿保留戶口重覆支付，如私下轉帳到舊戶口無法追蹤，即造成損失。</p>
      </div>
    </div>



    <div v-if="success" class="ts">充值成功!</div>
    <!--div>
      Window Width: {{ windowWidth }}
    </div-->
  </div>
</template>

<script>

import axios from "axios";

export default {
  // 你的组件选项...
  name : 'payPage',
  data(){
    return{
      timer: null,
      counter: 0,
      success : false,
      tableData : [
        {
          "key": "銀行編號",
          "val": "",
          "icon": false
        },
        {
          "key": "收款卡號",
          "val":  "",
          "icon": true
        },
        {
          "key": "收款姓名",
          "val":  "",
          "icon": true
        },
        {
          "key": "實際支付金額",
          "val": "",
          "icon": true
        },
        {
          "key": "訂單號",
          "val": "",
          "icon": true
        }
      ],
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    this.tableData[0].val = "預設銀行"; //params.get('bank_name');
    this.tableData[1].val = params.get('bank_no');
    this.tableData[2].val = params.get('card_name');
    this.tableData[3].val = params.get('amount');
    this.tableData[4].val = params.get('order_no').split('_')[1];
    //this.fetchUserData();
    //this.startTimer();
    setTimeout(this.startTimer,30000)
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.fetchUserData();
        this.counter += 1;
        if(this.counter >= 60)
          this.clearTimer();
      }, 3000); // 每秒增加
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    fetchUserData() {
      const params = new URLSearchParams(window.location.search);
      if(params.get('order_no') != null) {
        axios.get('https://86688abc123688.co/getPayStatus?order_no=' + params.get('order_no'))
            .then(response => {
              if (response.data.msg == '1' || response.data.msg == '3') {
                this.success = true;
                this.clearTimer();
              }
            })
            .catch(error => {
              console.error('There was an error!', error);
            });
      }
    },
    copy(v){
      const params = new URLSearchParams(window.location.search);
      let _val = v == 1 ?  params.get('bank_no') :  params.get('amount');
      this.copyText(_val);
    },
    copyText(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('复制成功');
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    renderHeader(h, { column }) {
      return h('span', [
        column.label,
        h('i', { class: 'el-icon-time' }) // 这里可以根据icon的值来动态切换类名
      ]);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.clearTimer();
  },
};
</script>

<style scoped>
@media only screen and (min-device-width: 768px) {
  .flex{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 0px;
  }
  .container {
    /* 原有 */
    width: 50%;
    min-width: 450px;
    max-width: 600px;
    padding: 10px;
    box-sizing: border-box;

    /* 边框 */
    border: 1px solid #fff;
    border-radius: 12px;

    /* 立体感核心 */
    background: #fff;
    box-shadow:
        0 4px 8px rgba(0, 0, 0, 0.08),
        0 10px 24px rgba(0, 0, 0, 0.06);

    /* 过渡（鼠标悬停更有质感） */
    transition: all 0.25s ease;
  }

  .el-table-page {
    border: 0px solid red;
    padding-top: 15px;
    width: 94% ;
    padding-left:5%;
    text-align: center;
  }

  .tableCss{
    width: 305px;
    left: 20%;
  }

  .top_cl{
    background-color: #6AD2F2;
    color:white;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如需要 */
    /*font-weight: bold;*/
  }

  .b1{
    font-weight: bolder;padding-top: 15px;font-size: 24px;text-align: center
  }

  .b2{
    font-weight: bolder;padding-top: 15px; font-size: 18px; text-align: left
  }

  .b3
  {
    height: 80px;width: 95%;text-align: left;padding-top: -6px;
    font-weight: bolder;
    text-align:left;
  }

  .ts{
    position:absolute;
    z-index: 99999;
    height: 150px;
    width: 200px;
    background-color: cornflowerblue;
    top: 160px;
    border-radius: 10px; /* 设置圆角的半径大小 */
    color:lavenderblush;
    font-weight: bold;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-table-border {
    border: 1px solid #d3dce6; /* 设置表格边框颜色 */
    /*border-collapse: collapse;  边框合并 */
    border-radius: 10px; /* 设置圆角的半径大小 */
  }

  .custom-table-border th,
  .custom-table-border td {
    border: 1px solid #d3dce6; /* 设置单元格边框颜色 */
  }

}



@media only screen and (max-device-width: 768px) {
  .flex{
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 10px;
  }
  /* 在屏幕宽度小于或等于768像素时应用以下样式 */
  .container {
    /* 手机端全屏 */
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 20px;
    left: 10px;
    z-index: 100; /* 确保div在其他内容之上 */
    border-color: coral;
    /* 其他样式 */


  }

  .el-table-page {
    padding-top: 15px;
    width: 94% ;
    padding-left:0%;
    text-align: center;
  }

  .tableCss{
    width: 305px;
    left: 9%;
  }

  .top_cl{color: #6AD2F2}
  /*.el-table-page {
    width: 100% ;
    left: 15%;
  }*/


  .top_cl{
    background-color: #6AD2F2;
    color:white;
    width: 95%;
    height: 50px;
    display: flex;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如需要 */
    font-weight: bold;
  }

  .b1{
    font-weight: bolder;padding-top: 15px;font-size: 24px;text-align: center
  }

  .b2{
    font-weight: bolder;padding-top: 15px; font-size: 18px; text-align: left
  }

  .b3
  {
    height: 100px;width: 95%;text-align: center;padding-top: -6px;
    font-weight: bolder;
    text-align: left;
  }

  .ts{
    position:absolute;
    z-index: 99999;
    height: 150px;
    width: 200px;
    background-color: cornflowerblue;
    top: 160px;
    border-radius: 10px; /* 设置圆角的半径大小 */
    color:lavenderblush;
    font-weight: bold;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .custom-table-border {
    border: 1px solid #d3dce6; /* 设置表格边框颜色 */
    /*border-collapse: collapse;  边框合并 */
    border-radius: 10px; /* 设置圆角的半径大小 */
  }

  .custom-table-border th,
  .custom-table-border td {
    border: 1px solid #d3dce6; /* 设置单元格边框颜色 */
    font-weight: bold;
    font-size: 18px;
  }

}
</style>